<template>
  <div>
    <div class="highlight subtitle2__color text-left text-uppercase">
      {{ theme }}
    </div>
    <h1 class="text-left text-uppercase">
      {{ name }}
    </h1>
    <div class="subtitle2 subtitle2__color text-left mt-5">
      {{ relatedProviders }}
    </div>
  </div>
</template>
<script>
import { get, find } from "@/utils/lodash";

export default {
  props: {
    blog: {
      type: Object,
      default: null,
    },
  },
  computed: {
    theme() {
      const foundAttribute = find(
        get(this.blog, "attributes"),
        (attr) => get(attr, "type.code") === "BLOG_THEME"
      );
      const val = get(foundAttribute, "value");

      if (val != null) {
        return val;
      }

      return "";
    },
    name() {
      return get(this.blog, "title");
    },
    author() {
      const author = `By ${get(this.blog, "user.firstName")} ${get(
        this.blog,
        "user.lastName"
      )}`;

      return author != null ? author : "";
    },
    relatedProviders() {
      var author = '';
      if(get(this.blog.relatedProviders[0], "name") != undefined){
         author = `${get(this.blog.relatedProviders[0], "name")} `;
      }
      return author != null ? author : "";
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";

h1 {
  color: #333333;
  letter-spacing: 0.6px;

  @media screen and (max-width: $media-md) {
    line-height: 36px;
  }
  // md +
  @media screen and (min-width: $media-md) {
    line-height: 50px;
    font-size: 48px;
  }
}
.subtitle2__color {
  color: $color-on-background-area1;
  font-size: 14px;
}
</style>
